import { InfoCards } from "../../_models";
import { DoughnutChartData } from "../data-visualization/doughnut-chart/doughnut-chart.component";
import { InlineTableData } from "../data-visualization/data-table/data-table.component";

export enum ProductViewType {
  Base = 'base',
  Campaign = 'campaign',
}

export enum OrdersInfo {
  CancelRequests = 0,
  Saved = 1,
  RevenueSaved = 2,
  RetentionRate = 3,
}

export interface OrdersBillingDualCard {
  leftLbl: string;
  leftVal: string;
  rightLbl: string;
  rightVal: string;
  subtitle: string;
  leftSubtitle?: string;
  rightSubtitle?: string;
  hint?: string;
}

export interface OrdersBillingSingleCard {
  label: string;
  value: string;
  trend_pct?: number | null;
  subtitle: string;
  hint?: string;
}

/* Top Info Cards */
export const ordersTopCards: InfoCards = [
  {
    title: "Cancel Order Requests",
    value: "--",
    hint: "Total number of customers who requested to cancel their order.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
    subtitleItems: [],
  },
  {
    title: "Orders Saved",
    value: "--",
    hint: "Total number of orders that were successfully saved.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
    subtitleItems: [],
  },
  {
    title: "Revenue Saved",
    value: "--",
    hint: "Total revenue retained from saved orders.",
    percentage: null,
    is_negative: false,
    subtitle: "Projected MRR protected",
  },
  {
    title: "Retention Rate",
    value: "--",
    hint: "The percentage of cancel requests that were successfully retained.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
  },
];

/* Retention Summary Doughnut */
export const ordersDoughnutData: DoughnutChartData = {
  data: [],
  noData: false,
  loading: true,
  total: "",
  labels: ["Saved", "Cancelled", "Abandoned", "Other"],
  backgroundColors: [
    {
      backgroundColor: ["#00D67E", "#FF8971", "#FFD666", "#CBD5E1"],
    },
  ],
};

export const ordersSummaryTableData: InlineTableData = [
  { name: "Saved", color: "#00D67E", value: "--", percentage: "--" },
  { name: "Cancelled", color: "#FF8971", value: "--", percentage: "--" },
  { name: "Abandoned", color: "#FFD666", value: "--", percentage: "--" },
  { name: "Other", color: "#CBD5E1", value: "--", percentage: "--" },
];

/* Top Cancellation Reasons */
export const ordersCancellationReasons = {
  data: [],
  loading: true,
  noData: false,
};

/* Billing Row — Dual Cards */
export const ordersBillingDualCards: OrdersBillingDualCard[] = [
  {
    leftLbl: "Total Billed",
    leftVal: "--",
    rightLbl: "Total Refunds",
    rightVal: "--",
    subtitle: "Total billed vs refunded amount",
    hint: "Total revenue billed and total amount refunded in the period.",
  },
  {
    leftLbl: "Partial Refunds",
    leftVal: "--",
    rightLbl: "Full Refunds",
    rightVal: "--",
    subtitle: "Breakdown of refunds by type",
    hint: "Breakdown of partial vs full refunds issued in the period.",
  },
];

/* Billing Row — Single Cards */
export const ordersBillingSingleCards: OrdersBillingSingleCard[] = [
  {
    label: "Avg. Refund Amount",
    value: "--",
    trend_pct: null,
    subtitle: "Average per refund transaction",
    hint: "The average refund amount per transaction in the selected period.",
  },
  {
    label: "Net Revenue",
    value: "--",
    trend_pct: null,
    subtitle: "Total billed minus refunds",
    hint: "Net revenue after subtracting all refunds.",
  },
];

export const ordersBillingState = { loading: true };

/* Performance by Offer Type */
export const ordersOfferTypeData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Product */
export const ordersProductData = {
  data: [],
  baseData: null as any[] | null,
  campaignData: null as any[] | null,
  loading: true,
  noData: false,
  type: ProductViewType.Base,
};

/* Performance by Campaign */
export const ordersCampaignData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Customer Stage */
export const ordersCustomerStageData = {
  data: [],
  loading: true,
  noData: false,
};

export const ordersHints = {
  retentionSummary: "An overview of order cancellation session outcomes.",
  cancellationReasons: "The most common reasons customers request to cancel their orders.",
  billing: "Revenue and refund metrics for the selected period.",
  offerType: "Performance of retention offers presented to customers during cancellation.",
  product: "Retention performance broken down by product.",
  campaign: "Retention performance grouped by marketing campaign.",
  customerStage: "Retention performance based on the customer's subscription stage.",
};
